import { MenuButton } from '@ui';

export interface RowAction {
  label: string;
  run: () => void;
  disabled?: boolean;
  /** Т14: why the item is off, in its tooltip (the menu cuts a hint beside a label to a letter). */
  hint?: string;
}

// Destructive row actions are drawn red by the library menu.
const DANGER = /^(Удалить|Отозвать)/;

/** Row actions behind the library's «⋯» menu (tables of the tracker: users, projects, tokens). */
export function RowMenu({ label, actions }: { label: string; actions: RowAction[] }) {
  if (actions.length === 0) return null;
  return (
    <MenuButton
      label={label}
      size="sm"
      items={actions.map((action) => ({
        key: action.label,
        label: action.label,
        disabled: action.disabled,
        ...(action.hint ? { tip: action.hint } : {}),
        danger: DANGER.test(action.label),
        onSelect: action.run,
      }))}
    />
  );
}
